import { render, staticRenderFns } from "./ServiceApp.vue?vue&type=template&id=10f944c8&scoped=true&"
import script from "./ServiceApp.vue?vue&type=script&lang=js&"
export * from "./ServiceApp.vue?vue&type=script&lang=js&"
import style0 from "./ServiceApp.vue?vue&type=style&index=0&id=10f944c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f944c8",
  null
  
)

export default component.exports